import React, { FC } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { Button, Image } from '@whitesharx/starfall-frontend-ui-kit';
import { Modal } from '../Modal';
import { imageStyles } from './styles.css';
import { buttonStyles, infoContainerStyles } from '../styles.css';

type ResignModalProps = {
  isOpen: boolean;
  onResign(): void;
  onRequestClose(): void;
};

const ResignModal: FC<ResignModalProps> = ({ isOpen, onResign, onRequestClose }) => (
  <Modal.Chess isOpen={isOpen} onRequestClose={onRequestClose} header={t('game.do-you-want-resign?')} maxWidth={600}>
    <Image className={imageStyles} src="assets/images/game/resign.webp" />
    <div className={infoContainerStyles}>
      <Button className={buttonStyles} onClick={onResign}>
        {t('button.resign')}
      </Button>
      <Button color="secondary" className={buttonStyles} onClick={onRequestClose}>
        {t('button.continue-play')}
      </Button>
    </div>
  </Modal.Chess>
);

export default ResignModal;
